export default __webpack_public_path__ + "static/media/logo-ae-giving.1a35d7a8.svg";